import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import useLocales from "src/hooks/useLocales";
import * as Yup from "yup";

import useCreateAppService from "../services/useCreateAppService";

export type NewAppForm = {
	name: string;
	displayName: string;
};

export default function useNewAppForm() {
	const { onCreateApp, isPending } = useCreateAppService();

	const { translate } = useLocales();

	const schema = Yup.object().shape({
		name: Yup.string()
			.required(translate("new_app.name_required"))
			.min(3, translate("new_app.name_min"))
			.max(30, translate("new_app.name_max")),
		displayName: Yup.string()
			.required(translate("new_app.public_name_required"))
			.min(3, translate("new_app.name_min"))
			.max(30, translate("new_app.name_max"))
	});

	const methods = useForm<NewAppForm>({
		resolver: yupResolver(schema),
		defaultValues: { name: "", displayName: "" }
	});

	async function onSubmit({ name, displayName }: NewAppForm) {
		onCreateApp(name, displayName);
	}

	return {
		methods,
		onSubmit: methods.handleSubmit(onSubmit),
		isLoading: isPending
	};
}
